<template>
<v-window v-model="step">
  <!-- <ui-loader v-model="loadingProducts" /> -->
  <v-window-item :value="1">
    <products-price-history-for-product
        :items="historicPrices"
        :priceHistoryDialog="priceHistoryDialog"
        :product="selectedProduct"
        v-on:close-dialog="closeDialog"
    />
    <v-toolbar v-if="searchStack.length > 0" dense>
        <v-toolbar-items v-for="s in searchStack" :key="s.value">
        <v-btn flat @click="goToSearch(s)">{{s.value}}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="purcharse-order mt-1">
      <v-layout row wrap justify-end>
        <v-flex
          :xs6="canSeeSelect"
          :xs12="!canSeeSelect">
          <v-combobox v-model="select"
            @click="selectAll"
            :loading="loading"
            :items="items"
            :search-input.sync="search"
            :item-text="selectedFilter.field"
            :item-value="selectedFilter.field"
            class="mx-1" hide-no-data hide-details
            :label="selectedFilter.name"
            solo
            v-on:keyup.enter="onEnterClick"
            ref="myAutocomplete"
            autofocus>
          </v-combobox>
        </v-flex>
        <v-flex xs4 v-if="hasRole('SUPERVISOR') || hasRole('ADMINISTRATOR') || hasRole('USER') || this.hasRole('METAL_LOAD_ADV') || this.hasRole('METAL_LOAD_BAS')">
          <v-select :items="filters" v-model="selectedFilter" solo item-text="name" item-value="id" return-object></v-select>
        </v-flex>
         <v-flex xs2>
          <v-select class="ml-1 ml-1" :items="filters2" v-model="selectedFilter2" solo item-text="name" item-value="id" return-object></v-select>
        </v-flex>

      </v-layout>
      <v-container p-0 m-0 class="buttons-container">
        <v-layout row wrap >
          <v-flex  >
            <v-icon 
              x-large 
              @click="goBack()"
              :color="primaryLayoutColor"
              :style="{'opacity': pathHistoryComputed}"
              :disabled="pathHistoryComputed == 0"
              >arrow_back</v-icon>
          </v-flex>
          <v-flex  class="right">
           <div>
            <v-icon @click="alternativeLayout = 0" :color="primaryLayoutColor">list</v-icon>
            <v-icon @click="alternativeLayout = 1" :color="alternativeLayoutColor">view_comfy</v-icon>
            <v-icon @click="showCacheStat=true" >info </v-icon>
            <cache-stats 
              :show="showCacheStat"
              @close="showCacheStat=false"
              v-on:update:returnValue="showCacheStat=false"
              />
           </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-layout row wrap v-if="productsToShow.length === 0" class="test">
          <v-img :src="myImage" aspect-ratio="1" max-width="400" contain></v-img>
      </v-layout>

      <v-container  v-if="!alternativeLayout">
         <product-row
            v-for="product in productsToShow" :key="product.id"
            :product="product"
            v-on:loadHistoricPrices="loadHistoryPrices"
            v-on:findSimilar="findSimilar">
         </product-row>
      </v-container>

      <v-container :class="{'px-1': $vuetify.breakpoint.smAndDown}" fluid grid-list-lg v-if="alternativeLayout">
        <v-layout row wrap>
          <v-flex xs12 sm4 md3 v-for="product in productsToShow" :key="product.id" :ref="productId(product)" >
          <product-card :product="product"
            v-on:loadHistoricPrices="loadHistoryPrices"
            v-on:findSimilar="findSimilar"
            v-on:no-picture="noPicture"
            v-on:get_price="showPrice"
            v-on:limit="limit"
          ></product-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-window-item>
  <v-window-item :value="2">
    <purcharse-order-small-line-item :product="selectedProduct" @set-step="setStep" />
  </v-window-item>
</v-window>
</template>

<script>
import _ from 'lodash';
import ProductCard from '../components/ui/ProductCard';
import ProductRow from '../components/ui/ProductRow';
import CacheStats from '../components/ui/CacheStats';
import productCardUtilitesMixin from '../mixins/productCardUtilitesMixin';
import product from '@/store/modules/product';

const DEBOUNCE_DELAY = 650;

export default {

  name: 'Products',
  components: {
    ProductCard,
    ProductRow,
    CacheStats,
  },
  mixins: [productCardUtilitesMixin],
  data() {
    return {
      myImage: require('@/assets/logoc.png'),
      step: 1,
      products: [],
      pictures: {},
      makerProducts: [],
      makerPictures: {},
      // Autocomplete data
      loading: false,
      loadingProducts: false,
      suggestions: [],
      search: null,
      select: null,
      selectedProduct: {},
      alternativeLayout: true,
      thumbQueryParam: '',

      selectedFilter: {
        id: 1,
        name: 'Serie',
        field: 'serial_number',
        endpoint: ''
      },
      selectedFilter2: {
        id: 1,
        name: 'Comienza por',
        field: 'begin'
      },
      filters: [{
          id: 1,
          name: 'Serie',
          field: 'serial_number',
          endpoint: '' ,
        },
        {
          id: 2,
          name: 'Marca',
          field: 'maker_name',
          endpoint: '/catalogs/product/searchByMaker',
        },
        {
          id: 3,
          name: 'Descripción',
          field: 'description',
          endpoint:  '',
        },
      ],
      filters2: [{
          id: 1,
          name: 'Comienza por',
          field: 'begin',
        },
        {
          id: 2,
          name: 'Contiene',
          field: 'contain',
        },
        {
          id: 3,
          name: 'Termina con',
          field: 'end',
        },
        {
          id: 4,
          name: 'Exacto',
          field: 'exact',
        },
      ],
      reqBody: {
        pagination: {
          current_page: 1,
          per_page: 20,
        },
      },
      currentPage: 1,
      perPage: 400,
      scrollLoading: false,
      endOfFilter: false,
      findingSimilar: false,

      fab: false,

      historicPrices: [],
      priceHistoryDialog: false,

      searchStack: [],
      showCacheStat: false,
      pathHistory: [],
      searchBackup: ""
    };
  },

  watch: {
    selectedFilter() {
      this.suggestions = [];
      if (this.search) {
        this.searchProducts();
      }
    },
    search(val) {
      return val && val !== this.select && this.querySelections(val);
    },
    select() {
      if (this.select && typeof this.select === 'object') {
        this.search = this.select[this.selectedFilter.field];
        this.onEnterClick();
      }
    },
  },

  computed: {
    pathHistoryComputed() {
      return this.pathHistory.length > 0 ? 1 : 0
    },
    items() {
      return this.suggestions.map((entry) => {
        const serialNumber = entry.serial_number;
        return Object.assign({}, entry, {
          serialNumber,
        });
      });
    },
    flexClass() {
      return {
        xs12: this.hasRole('CLIENT'),
        xs8: this.hasRole('ADMINISTRATOR') || this.hasRole('USER') || this.hasRole('METAL_LOAD_ADV') || this.hasRole('METAL_LOAD_BAS') ,
      };
    },
    productsToShow() {
      if (this.products === undefined){
        this.products = []
      }
      if (this.findingSimilar) {
        this.product = this.products.sort((a, b) => (a.pesos_price < b.pesos_price) ? -1 : 1 )[0];
      }
      if (this.currentType === 'CLIENT' && this.findingSimilar && this.product) {
        if (this.product.length === 1) {
          return this.products;
        }
        const PERCENTAGE = 40;
        const LIMIT_FACTOR = 1.0 + (PERCENTAGE / 100);
        const cheaper = this.products[0];
        const UPPER_LIMIT = cheaper.pesos_price * LIMIT_FACTOR;
        return this.products.filter((p) => {
          const shouldShow = p.pesos_price <= UPPER_LIMIT;
          return shouldShow;
        });
      } else {
        return this.products.filter((p) => {
          const shouldShow =
            (this.selectedFilter.id === 2 && p.picture_path) || this.selectedFilter.id !== 2;
          return shouldShow;
        });
      }
    },
    alternativeLayoutColor() {
      return this.alternativeLayout ? 'orange' : '';
    },
    primaryLayoutColor() {
      return !this.alternativeLayout ? 'orange' : '';
    },
    canSeeSelect() {
      return  this.hasRole('SUPERVISOR') || this.hasRole('ADMINISTRATOR') || this.hasRole('USER') || this.hasRole('METAL_LOAD_ADV') || this.hasRole('METAL_LOAD_BAS');
    },
  },
  methods: {
    limit() {
      this.$emit('error', "Limite de consultas diarias alcanzado");
    },
    showPrice(product) {
      const index = this.products.findIndex(localProduct => {
        return  localProduct.product_id === product.product_id
      })
      if (index >= 0) {
        this.products[index].pesos_price = product.pesos_price
        this.products[index].weigth_grams = product.weigth_grams
        
        const temp = JSON.parse(JSON.stringify(this.products))
        this.products = temp
      }
    },
    /**
     * Based on https://alligator.io/vuejs/implementing-infinite-scroll/ (Apr 2019)
     */
    goBack(){
      this.pathHistory.pop()
      if(this.pathHistory == 0){
        console.log(this.searchStack);
        const value = {
          filter: this.$route.query.filter,
          value: this.$route.query.value,
          from: undefined,
        };
        this.findingSimilar = false
      //  this.doOtherSearch(value);
      this.search = this.searchBackup
      this.searchProducts()
      }else{
        this.findSimilar(this.pathHistory[this.pathHistory.length -1], false)
      }
    },
    scroll(products, pictures) {
      window.onscroll = async () => {
        try {
          const bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
          if (bottomOfWindow && !this.scrollLoading && !this.endOfFilter && !this.loadingProducts) {
            if (!this.reqBody.maker_name && !this.reqBody.serial_number && !this.reqBody.description) {
              return;
            }
            this.scrollLoading  = true;
            this.currentPage = this.currentPage + 1;
            this.reqBody.pagination = {
              current_page: this.currentPage,
              per_page: this.perPage,
            };
            const that = this;
            const results =
              await this.axios.post(`${this.selectedFilter.endpoint}?${this.thumbQueryParam}`, this.reqBody);

            if (!results.data.products || results.data.products.length === 0) {
              that.endOfFilter = true;
              return;
            }
            that.products = that.products.concat(results.data.products);
            that.pictures = {...that.pictures, ...results.data.pictures };
          }
        } catch (error) {
          this.$emit('error', error);
        } finally {
          this.scrollLoading = false;
        }
      };
    },
    // This functionality is implemented by search all the products that have the same picture
    async findSimilar(path, addPath) {
      try {
        if (addPath != false){
          this.pathHistory.push(path)
        }
        this.currentPage = 1;
        this.endOfFilter = false;
        this.scrollLoading = false;
        this.search = '';
        this.$vuetify.goTo(0);
        this.products = [];
        this.pictures = [];

        this.loadingProducts = true;
        this.reqBody = {
          picture_path: path,
          no_zero: true,
          pagination: {
            current_page: this.currentPage,
            per_page: this.perPage,
          },
        };
        if (this.selectedFilter.field === 'maker_name' && this.searchStack.length < 2) {
          this.searchStack.push({ filter: this.selectedFilter.field, value: this.select, from: path });
          console.log(this.searchStack);
        }
        const results = (this.hasRole('ADMINISTRATOR') || this.hasRole('SUPERVISOR') || this.hasRole('METAL_LOAD_ADV') || this.hasRole('METAL_LOAD_BAS') ||  this.hasRole('USER')) ?
        await this.axios.post(`/catalogs/product/search?${this.thumbQueryParam}`, this.reqBody)
        :
        await this.axios.post(`/catalogs/product/search/limit?${this.thumbQueryParam}`, this.reqBody)
        console.log(results);
        if (results.status === 204){
            this.$emit('error', "Limite de consultas diarias alcanzado");
        }else{
          this.products = results.data.products;
          this.pictures = results.data.pictures;
         }
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.loadingProducts = false;
        this.findingSimilar = true;
        delete this.reqBody.picture_path;
      }

    },

    async searchProducts() {
      try {
        this.currentPage = 1;
        this.endOfFilter = false;
        this.scrollLoading = false;
        this.products = [];
        this.pictures = [];
        this.findingSimilar = false;

        this.loadingProducts = true;
        if (this.search && this.search !== '') {
          this.reqBody = {
            [this.selectedFilter.field]: this.search,
            no_zero: true,
            searchExact: this.selectedFilter2.field,
            pagination: {
              current_page: this.currentPage,
              per_page: this.perPage,
            },
          };
          const results = await this.axios
            .post(`${this.selectedFilter.endpoint}?${this.thumbQueryParam}`, this.reqBody);
          if (results.status === 204){
            this.$emit('error', "Limite de consultas diarias alcanzado");
          }else{
            this.searchBackup = this.search
            this.products = results.data.products;
            this.pictures = results.data.pictures;
            if (this.selectedFilter.id === 2) {
              this.makerProducts = this.products;
              this.makerPictures = this.pictures;
            }
          }
        }
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.$refs.myAutocomplete.isMenuActive = false;
        this.loadingProducts = false;
      }
    },
    onEnterClick() {
      this.searchProducts();
    },
    querySelections: _.debounce(function(v) {
      this.loading = true;
      const reqBody = {
        q: v,
      };
      this.pathHistory = []

      let endpoint = '/catalogs/product/searchSN';
      if (this.selectedFilter.id === 2) {
        endpoint = '/catalogs/maker/search';
      } else if (this.selectedFilter.id === 3) {
        endpoint = undefined;
        this.suggestions = [];
        this.loading = false;
      }

      if (endpoint) {
        this.axios.post(endpoint, reqBody)
          .then((results) => {
            this.suggestions = results.data;
            this.loading = false;
          })
          .catch((error) => {
            this.$emit('error', error);
            this.loading = false;
          });
      }
    }, DEBOUNCE_DELAY),

    selectProduct(product) {
      this.step = 2;
      this.selectedProduct = Object.assign({}, product);
    },
    setStep(step) {
      this.step = step;
    },
    closeDialog() {
      this.priceHistoryDialog = false;
    },
    loadHistoryPrices(product) {
      let endpoint = `/priceHistory/historic/sn?serial_number=${product.serial_number}`;
      if (product.pair) {
        endpoint = endpoint + `&pair=1`;
      }

      this.axios.get(endpoint)
      .then((response) => {
        this.historicPrices = response.data;
        this.selectedProduct = product;
        this.priceHistoryDialog = true;
      })
      .catch((error) => {
        this.$emit('error', error);
      });
    },

    goToSearch(value) {
      if (this.makerProducts) {
        this.products = this.makerProducts;
        this.pictures = this.makerPictures;
        this.$nextTick(() =>  {
            if (value.from) {
              const element = this.$refs[value.from];
              if (element) {
                const top = element[0].$el.offsetTop;
                window.scrollTo(0, top);
              }
            }
          });
      } else {
        this.doOtherSearch(value);
      }
      this.select = value.value;
      this.search = value.value;
      this.searchStack.pop();
      this.searchStack = [];
    },

    doOtherSearch(objetValue) {

      const {filter, value, from} = objetValue;
      this.select = value;
      if (filter && value) {
        if (filter === 'maker_name') {
          this.selectedFilter = this.filters[1];
        } else if (filter === 'description') {
          this.selectedFilter = this.filters[2];
        }
      }
      this.reqBody[this.selectedFilter.field] = this.select;
      this.reqBody.no_zero = true;

      this.loadingProducts = true;
      this.axios.post(`${this.selectedFilter.endpoint}?${this.thumbQueryParam}`, this.reqBody)
        .then((results) => {
          if (results.status === 204){
            this.$emit('error', "Limite de consultas diarias alcanzado");
          }else{
            this.products = results.data.products;
            this.pictures = results.data.pictures;
            // Goto something
            this.$nextTick(() =>  {
              if (from) {
                const element = this.$refs[from];
                if (element) {
                  const top = element[0].$el.offsetTop;
                  window.scrollTo(0, top);
                }
              }
            });
          }
        })
        .catch((error) => {
          this.$emit('error', error);
        })
        .finally(() => {
          this.loadingProducts = false;
        });
    },
    selectAll(event) {
      event.target.setSelectionRange(0, event.target.value.length);
    },
    noPicture(product) {
      if (this.selectedFilter.name === 'Marca') {
        // Remove flex without pictures
        const id = this.productId(product);
        const reference = this.$refs[id];
        reference[0].hidden = true;
      }
    },
    productId(product) {
      return product.id || '' + `_${product.picture_path}`;
    },
    toggleCacheStat() {
      this.showCacheStat = true;
    },
  },
  mounted() {
    if(this.hasRole('ADMINISTRATOR') || this.hasRole('SUPERVISOR') || this.hasRole('METAL_LOAD_ADV') || this.hasRole('METAL_LOAD_BAS') || this.hasRole('USER') ) {
      this.selectedFilter.endpoint = '/catalogs/product/search'
    }else {
      this.selectedFilter.endpoint = '/catalogs/product/search/limit'
    }
    this.filters[0].endpoint = this.selectedFilter.endpoint
    this.filters[2].endpoint = this.selectedFilter.endpoint
    this.$vuetify.goTo(0);
    this.scroll(this.products);
    if (this.hasRole('ADMINISTRATOR') || this.hasRole('SUPERVISOR') || this.hasRole('USER') || this.hasRole('METAL_LOAD_ADV') || this.hasRole('METAL_LOAD_BAS')) {
      let marker = this.$route.params.branch
      if(!!marker){
        this.suggestions = [];
        this.selectedFilter = {
          id: 2,
          name: 'Marca',
          field: 'maker_name',
          endpoint: '/catalogs/product/searchByMaker',
        }
        this.search = marker
        this.searchProducts();
      }else{
      // const value = {
      //   filter: this.$route.query.filter,
      //   value: this.$route.query.value,
      //   from: undefined,
      // };
      // this.doOtherSearch(value);
      }
    }
  },
};
</script>
<style>

.test {
  align-items: center;
  justify-content: center;
}

.buttons-container {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important; 
}

.right {
  display: flex;
  align-items: flex-end;
  justify-content: end;
}
</style>